import React  from "react";
import { Tabs } from 'antd';
import Card from "components/card";
import Button from "components/button";
import PayrunDtrTable from "./components/PayrunDtrTable";
import PayrunOtTable from "./components/PayrunOtTable";
import PayrunNdTable from "./components/PayrunNdTable";
import PayrunEmployee from "./components/PayrunEmployee";
import { connect } from "react-redux";
import { NumberFormatter } from "../../../utils/index";
import { useParams } from 'react-router-dom';
import { 
	doPayrollPayrunSync
} from "../../../redux/payrun/payrunState";

const ViewPayrun = ({recordData, doPayrunSync }) => {
	
	const { payrunId } = useParams();
	
	const totalEarnings = recordData?.incomePaycodeLis?.reduce((total, item) => {
	  const amount = parseFloat(recordData?.[item.amount]);
	  if (isNaN(amount)) {
	    console.log(`Invalid amount: ${recordData?.[item.amount]} for item: ${item.name}`);
	    return total;
	  }
	  return amount !== 0 ? total + amount : total;
	}, 0);

	const totalDeductions = recordData?.deductionPaycodeList?.reduce((total, item) => {
	  const amount = parseFloat(recordData?.[item.amount]);
	  if (isNaN(amount)) {
	    console.log(`Invalid amount: ${recordData?.[item.amount]} for item: ${item.name}`);
	    return total;
	  }
	  return amount !== 0 ? total + amount : total;
	}, 0);
	
	const totalAdditionalEarnings = recordData?.additionalIncomePaycodeList?.reduce((total, item) => {
	  const amount = parseFloat(recordData?.[item.amount]);
	  if (isNaN(amount)) {
	    return total;
	  }
	  return amount !== 0 ? total + amount : total;
	}, 0);
	
	const totalAdditionalDeductions = recordData?.additionalDeductionPaycodeList?.reduce((total, item) => {
	  const amount = parseFloat(recordData?.[item.amount]);
	  if (isNaN(amount)) {
	    return total;
	  }
	  return amount !== 0 ? total + amount : total;
	}, 0);
    
    const items = [
	  	{
	    	key: '1',
		    label: 'DTR',
		    children: <PayrunDtrTable payrunId={payrunId}/>,
	  	},
	  	{
		    key: '2',
		    label: 'Overtime',
		    children: <PayrunOtTable payrunId={payrunId}/>,
	  	},
	  	{
		    key: '3',
		    label: 'Night Differential',
		    children: <PayrunNdTable payrunId={payrunId}/>,
	  	},
	];
	
	const resyncDtrHandler = () => {
		doPayrunSync(payrunId);
	}

	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	    		<PayrunEmployee recordId={payrunId}/>
	    		
	    		<Card extra={"w-full h-full p-4"}>
	      			<Tabs defaultActiveKey="1" items={items}/>
	      		</Card>
	      		{recordData?.payroll?.pay_status_id < 8 && (
	      			<div className="flex flex-row-reverse text-right">
		      			{/*<Button className="me-3">
                            DTR Validated
                        </Button>*/}
		      			<Button className="btn-danger me-3" 
		      				onClick={resyncDtrHandler}>
	                        Re-Sync DTR
	                    </Button>
                   </div>
	      		)}
				{recordData?.payroll?.pay_status_id == 8 && (
	      			<div className="flex flex-row-reverse text-right">
						<a className="btn btn-primary me-3" href={`/console/payrolls/${recordData?.payroll?.pay_id}/payruns/${payrunId}/edit`}>
							Manual Edit DTR
						</a>
                   </div>
	      		)}

	      		{recordData?.payroll?.pay_status_id >= 8 && (<>
	      		<Card extra={"w-full h-full p-4 content-wrapper"}>
					<div className="content-wrapper">
	      			<h4 className="card-title mb-5">
			            Summary
			        </h4>
			        
			        <div className="grid grid-cols-4 gap-4 mb-4 p-2 border border-brand-600 rounded">
			        	<div className="flex flex-col gap-1">
			        		<div className="font-medium">Basic Pay</div>
			        		<div className="ps-4">{NumberFormatter(recordData?.ppr_base_pay)}</div>
			        	</div>
			        	<div className="flex flex-col gap-1">
			        		<div className="font-medium">Daily Rate</div>
			        		<div className="ps-4">{NumberFormatter(recordData?.ppr_daily_rate)}</div>
			        	</div>
			        	<div className="flex flex-col gap-1">
			        		<div className="font-medium">Hourly Rate</div>
			        		<div className="ps-4">{NumberFormatter(recordData?.ppr_hour_rate)}</div>
			        	</div>
			        	<div className="flex flex-col gap-1">
			        		<div className="font-medium">Total Work Hours</div>
			        		<div className="ps-4">{NumberFormatter(recordData?.ppr_total_wh)}</div>
			        	</div>
			        </div>
			        
			        <div className="grid grid-cols-2 gap-4">
			        	<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">
			        		<div className="font-bold">Earnings</div>
			        		<div className="flex flex-row gap-4 justify-between" key="basic_pay">
			                    <div className="font-medium">Basic Pay</div>
		                   		<div className="text-right pe-2">{NumberFormatter(recordData?.ppr_base_pay)}</div>
		                  	</div>			        		
							{recordData?.incomePaycodeLis?.map((item) => (
				              (!isNaN(parseFloat(recordData?.[item.amount])) && parseFloat(recordData?.[item.amount]) !== 0) && (
			                  	<div className="flex flex-row gap-4 justify-between" key={item.name}>
				                    <div className="font-medium">{item.name} {item.hours && `(${NumberFormatter(recordData?.[item.hours])} hrs.)`}</div>
			                   		<div className="text-right pe-2">{NumberFormatter(recordData?.[item.amount])}</div>
			                  	</div>
				                )
				            ))}				            
			        	</div>
			        	<div className="flex flex-col gap-2 p-1 border border-brand-600 rounded">
			        		<div className="font-bold">Deductions</div>
			        		{recordData?.deductionPaycodeList?.map((item) => (
				                (!isNaN(parseFloat(recordData?.[item.amount])) && parseFloat(recordData?.[item.amount]) !== 0) && (
				                  <div className="flex flex-row gap-4 justify-between" key={item.name}>
				                    <div className="font-medium">{item.name}</div>
				                    <div className="text-right pe-2">{NumberFormatter(recordData?.[item.amount])}</div>
				                  </div>
				                )
				            ))}	                       
			        	</div>
			        </div>
			        <div className="grid grid-cols-2 gap-4 mb-2">
			        	<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">			        		
				            <div className="flex flex-row gap-4 justify-between">
			                    <div className="font-bold">Total Earnings</div>
		                   		<div className="font-bold text-right pe-2">{NumberFormatter(totalEarnings + parseFloat(recordData?.ppr_base_pay))}</div>
		                  	</div>
			        	</div>
			        	<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">			        		
	                        <div className="flex flex-row gap-4 justify-between">
			                    <div className="font-bold">Total Deductions</div>
		                   		<div className="font-bold text-right pe-2">{NumberFormatter(totalDeductions)}</div>
		                  	</div>
			        	</div>
			        </div>
			        
			        {(totalAdditionalEarnings !== 0 || totalAdditionalDeductions !== 0) && 
			        (<>
			        	<div className="grid grid-cols-2 gap-4">
			        		<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">
				        		<div className="font-bold">Additional Earnings</div>
				        		{recordData?.additionalIncomePaycodeList?.map((item) => (
				                (!isNaN(parseFloat(recordData?.[item.amount])) && parseFloat(recordData?.[item.amount]) !== 0) && (
				                  <div className="flex flex-row gap-4 justify-between" key={item.name}>
				                    <div className="font-medium">{item.name}</div>
				                    <div className="text-right pe-2">{NumberFormatter(recordData?.[item.amount])}</div>
				                  </div>
				                )
				            ))}
				        	</div>
			        		<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">
				        		<div className="font-bold">Additional Deductions</div>
				        		{recordData?.additionalDeductionPaycodeList?.map((item) => (
				                (!isNaN(parseFloat(recordData?.[item.amount])) && parseFloat(recordData?.[item.amount]) !== 0) && (
				                  <div className="flex flex-row gap-4 justify-between" key={item.name}>
				                    <div className="font-medium">{item.name}</div>
				                    <div className="text-right pe-2">{NumberFormatter(recordData?.[item.amount])}</div>
				                  </div>
				                )
				            ))}
				        	</div>
				        </div>
							
						<div className="grid grid-cols-2 gap-4 mb-2">
			        		<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">			        		
					            <div className="flex flex-row gap-4 justify-between">
				                    <div className="font-bold">Total Additional Earnings</div>			        		
			                   		<div className="font-bold text-right pe-2">{NumberFormatter(totalAdditionalEarnings)}</div>
			                  	</div>
				        	</div>
			        		<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">			        		
		                        <div className="flex flex-row gap-4 justify-between">
				                    <div className="font-bold">Total Additional Deductions</div>
				        			<div className="font-bold text-right pe-2">{NumberFormatter(totalAdditionalDeductions)}</div>
			                  	</div>
				        	</div>
				        </div>				        
			        </>)
			        }
			        
			        <div className="grid grid-cols-2 gap-4 mb-2">
			        	<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">
			                  <div className="flex flex-row gap-4 justify-between">
			                    <div className="font-bold">GROSS EARNINGS</div>
			                    <div className="text-right pe-2 font-bold">{NumberFormatter(recordData?.ppr_gross_pay)}</div>
			                  </div>
			        	</div>
			        	<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">
			                  <div className="flex flex-row gap-4 justify-between">
			                    <div className="font-bold">Withholding Tax</div>
			                    <div className="text-right pe-2 font-bold">{NumberFormatter(recordData?.ppr_withholding_tax)}</div>
			                  </div>
			        	</div>
			        </div>
			        
			        <div className="grid grid-cols-2 gap-4 mb-2">			        	
			        	<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">
			                  <div className="flex flex-row gap-4 justify-between">
			                    <div className="font-bold">NET PAY</div>
			                    <div className="font-bold text-right pe-2">{NumberFormatter(recordData?.ppr_net_pay)}</div>
			                  </div>			                  
			        	</div>
			        	<div className="flex flex-col gap-2 p-2 rounded">
			                  <div className="flex flex-row gap-4 justify-between">
			                    <div className="font-bold"></div>
			                    <div className="font-bold text-right pe-2"></div>
			                  </div>			                  
			        	</div>
			        </div>
			        <div className="grid grid-cols-2 gap-4">			        	
			        	<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">
			                  <div className="flex flex-row gap-4 justify-between">
			                    <div className="font-bold">Leave Balance (hours)</div>
			                    <div className="text-right pe-2"></div>
			                  </div>
			        	</div>	
			        	<div className="flex flex-col gap-2 p-2 border border-brand-600 rounded">
			        	{recordData?.loanBalances?.map((item) => (
							<div className="flex flex-row gap-4 justify-between" key={item.name}>
			                    <div className="font-bold">{item.name}</div>
			                    <div className="text-right pe-2">{NumberFormatter(item.balance)}</div>
		                  	</div>				                  
			            ))}	 			                  
			        	</div>			        	
			        </div>
					</div>
	      		</Card>
	      		</>)}
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
  	recordData: state.payrun.payrunDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	doPayrunSync: (id) => dispatch(doPayrollPayrunSync(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewPayrun);